'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GECKO_UTILS = function () {
	function GECKO_UTILS() {
		_classCallCheck(this, GECKO_UTILS);
	}

	_createClass(GECKO_UTILS, null, [{
		key: 'generateUniqueId',
		value: function generateUniqueId() {
			return Math.floor(Math.random() * 0xFFFF).toString();
		}

		/*
  * For preparing class names
  * https://www.npmjs.com/package/classnames
  */

	}, {
		key: 'classNames',
		value: function classNames() {
			var _arguments = arguments;

			var hasOwn = {}.hasOwnProperty;

			return function () {
				var classes = [];

				for (var i = 0; i < _arguments.length; i++) {
					var arg = _arguments[i];
					if (!arg) continue;

					var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

					if (argType === 'string' || argType === 'number') {
						classes.push(arg);
					} else if (Array.isArray(arg)) {
						classes.push(GECKO_UTILS.classNames.apply(null, arg));
					} else if (argType === 'object') {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					}
				}

				return classes.join(' ');
			}();
		}

		/**
   * Set a nested value on an object by a dot seperated key string, this will return a new instance of the object
   * @param {object} obj - The object you want to assign the value on
   * @param {string} key - A string of keys seperated by dots which target the value you want to set
   * @param {any} value  - The value you want to set
   * @return {object} - A new object instance with the nested value set
   */

	}, {
		key: 'setNestedValue',
		value: function setNestedValue(obj, key, value) {
			var _key$split = key.split('.'),
			    _key$split2 = _toArray(_key$split),
			    keyFragment = _key$split2[0],
			    rest = _key$split2.slice(1);

			if (!rest.length) {
				return Object.assign({}, obj, _defineProperty({}, keyFragment, value));
			} else {
				return Object.assign({}, obj, _defineProperty({}, keyFragment, this.setNestedValue(obj[keyFragment], rest.join('.'), value)));
			}
		}

		/**
   * Get a nested value on an object by a dot seperated key string.
   * @param {object} values - The object you want to get the nested value on
   * @param {string} key - The string of keys seperated by dots which target the value you want to get
   * @return {any} - The nested value
   */

	}, {
		key: 'getNestedValue',
		value: function getNestedValue(values, key) {
			var keyFragments = key.split('.');
			var getValue = function getValue(obj, key) {
				return obj[key];
			};
			return keyFragments.reduce(getValue, values);
		}

		/**
   *  Output error message from an array or object
   *  @param Errors string | array | object
   */

	}, {
		key: 'renderError',
		value: function renderError(error) {
			var defaultMessage = 'Sorry, there was an error. Please try again.';

			if (typeof error === 'string' && error.length > 0) {
				return error;
			}

			if (error instanceof Array && error.length > 0) {
				return this.renderError(error[0]);
			}

			if (error instanceof Object && Object.keys(error).length > 0) {
				return this.renderError(error[Object.keys(error)[0]]);
			}

			return defaultMessage;
		}

		/**
   *  Get the contrasting color (black or white) for a provided hex code
   *  @param Hexcolor string 
   */

	}, {
		key: 'getContrastColor',
		value: function getContrastColor(hexcolor) {
			if (!hexcolor) return 'white';
			hexcolor = hexcolor.indexOf('#') > -1 ? hexcolor.replace('#', '') : hexcolor;
			var r = parseInt(hexcolor.substr(0, 2), 16);
			var g = parseInt(hexcolor.substr(2, 2), 16);
			var b = parseInt(hexcolor.substr(4, 2), 16);
			var yiq = (r * 299 + g * 587 + b * 114) / 1000;
			return yiq >= 128 ? '#1a252f' : 'white';
		}
	}, {
		key: 'prepareIndexClass',
		value: function prepareIndexClass(prefix, index) {
			if (index === undefined) return '';
			return (prefix + '-' + index).replace(' ', '-').toLowerCase();
		}
	}, {
		key: 'prepareNameClass',
		value: function prepareNameClass(prefix, name) {
			if (name === undefined) return '';
			return (prefix + '-' + name).replace(' ', '-').replace('.', '-').toLowerCase();
		}
	}]);

	return GECKO_UTILS;
}();

exports.default = GECKO_UTILS;